import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { GridRowModel } from '@mui/x-data-grid-pro';
import LegendBox from '../../../../../../../Components/Legend/LegendBox';
import { IBusinessColorConfig } from '../../../../Const/BusinessConfigs';

interface IProps {
  row: GridRowModel;
  colors: IBusinessColorConfig[];
}

const useStyles = makeStyles()(theme => ({
  legendContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    height: '100%',
    alignItems: 'center',
  },
  tableLineBreak: {
    flexBasis: '100%',
  },
}));

const BusinessDataTableInfoCell = (props: IProps): React.ReactElement<any> => {
  const { classes } = useStyles();

  const legendPosts = props.colors.filter(post =>
    post.condition(props.row.collectionData)
  );

  if (legendPosts.length > 0) {
    return (
      <div className={classes.legendContainer}>
        {legendPosts.map((legendPost, index) => (
          <React.Fragment key={index}>
            <LegendBox
              legendData={legendPost}
              noMargin={index % 2 === 1}
              notSpaced={index <= 1}
            />
            {index % 2 === 1 && legendPosts.length > index + 1 && (
              <div className={classes.tableLineBreak} />
            )}
          </React.Fragment>
        ))}
      </div>
    );
  } else {
    return <></>;
  }
};

export default BusinessDataTableInfoCell;
